export default __webpack_public_path__ + "static/media/logo-item-4.4ebb82db.jpeg";